import { Component, ChangeDetectionStrategy, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-osi',
  templateUrl: './osi.component.html',
  styleUrls: ['./osi.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OsiComponent {
  @Output() add = new EventEmitter<string>();
  @Output() delete = new EventEmitter<number>();
  @Input() tall = false;
  @Input() formArray: UntypedFormArray;
  @Input() formGroup: UntypedFormGroup;
  inputValue = '';

  constructor() {}

  addOsi() {
    if (this.inputValue !== '') {
      this.add.emit(this.inputValue);
      this.inputValue = '';
    }
  }
}
